import { Button, Typography } from "@mui/material";
import React from "react";
import type { ContentGetKantungParkir } from "../../constants/types";

interface IKantongCardProps {
    data: ContentGetKantungParkir;
    selectedKantong: ContentGetKantungParkir | null;
    handleSelectKantong: (kantong: ContentGetKantungParkir) => void;
    icon?: React.ReactNode;
}

const KantongCard = ({
    icon,
    data,
    selectedKantong,
    handleSelectKantong,
}: IKantongCardProps) => {
    return (
        <Button
            variant={selectedKantong?.id === data.id ? "contained" : "outlined"}
            onClick={() => handleSelectKantong(data)}
            sx={{
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: 1.5,
                borderRadius: 3,
                gap: 1,
                minHeight: 200,
                width: 200,
                textTransform: "none",
            }}
        >
            {icon}
            <Typography variant="h6" fontWeight={700} textAlign="center">
                {data.nama}
            </Typography>
        </Button>
    );
};

export default KantongCard;
